import { useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import { auth } from '@actions/services/firestore/browser/firebase';
import { useVoxityLogin } from '@voxityai/auth/hooks';
import { InitialDataProvider } from './contexts/InitialDataContext';
import router from './router';

const App = () => {
    const redirectUri = useMemo(() => window.location.origin, []);
    useVoxityLogin({
        auth,
        authServerUrl: import.meta.env.VITE_AUTH_SERVER_URL || '',
        redirectUri,
    });

    return (
        <InitialDataProvider>
            <RouterProvider router={router} />
        </InitialDataProvider>
    );
};

export default App;
